import { Alert, Button, LinearProgress } from "@mui/material";
import BackLink from "../shared/BackLink";
import { Add } from "@mui/icons-material";
import { useState } from "react";
import AddEditPopup from "./AddEditPopup";
import { useCollection } from "react-firebase-hooks/firestore";
import { useDb } from "../../contexts/DatabaseContext";
import PopupsList from "./PopupsList";

export default function Popups() {
  const { popupsQuery } = useDb();

  const [snapshot, loading, error] = useCollection(popupsQuery);
  const [editOpopupId, setEditPopupId] = useState();
  const [editPopupData, setEditPopupData] = useState();
  const [addEditOpen, setAddEditOpen] = useState(false);

  const handleAddEditOpen = () => {
    setAddEditOpen(true);
  };

  const handleAddEditClose = () => {
    setEditPopupId(null);
    setEditPopupData(null);
    setAddEditOpen(false);
  };

  const handleEdit = (id, popupData) => {
    setEditPopupId(id);
    setEditPopupData(popupData);
    handleAddEditOpen();
  };

  if (loading) {
    return <LinearProgress />;
  }

  const popups = snapshot?.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  console.log(popups);

  if (error) {
    return <Alert severity="error">{error.message}</Alert>;
  }

  return (
    <div>
      <h1>Popups</h1>
      <BackLink />
      <Button
        startIcon={<Add />}
        color="primary"
        variant="contained"
        onClick={handleAddEditOpen}
      >
        Add New Popup
      </Button>
      <br />
      <br />
      {popups && <PopupsList popups={popups} handleEdit={handleEdit} />}

      <AddEditPopup
        open={addEditOpen}
        close={handleAddEditClose}
        popupId={editOpopupId}
        popupData={editPopupData}
      />
    </div>
  );
}
